import { faBell } from "@fortawesome/pro-solid-svg-icons";
import React from "react";
import NotificationsFeed from "../../components/CommandCenter/notificationsFeed";
import ComponentHeader from "../../components/UI/ComponentHeader";
import { CommandMessage } from "../CommandTypes";

interface DashboardJobsiteAlertsProps {
    messages: CommandMessage[];
    timezone: string;
}

const DashboardJobsiteAlerts: React.FC<DashboardJobsiteAlertsProps> = ({ messages, timezone }) => {
    return (
        <div className="grow flex flex-col gap-2 h-full w-full overflow-hidden">
            <ComponentHeader label="Jobsite Alerts" icon={faBell} color="text-plot-orange" />
            <NotificationsFeed messages={messages} timezone={timezone} />
        </div>
    );
};

export default DashboardJobsiteAlerts;
